import { render, staticRenderFns } from "./FortisTenantDashboardWidget.vue?vue&type=template&id=4c0b99cd&scoped=true"
import script from "./FortisTenantDashboardWidget.vue?vue&type=script&lang=js"
export * from "./FortisTenantDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./FortisTenantDashboardWidget.vue?vue&type=style&index=0&id=4c0b99cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0b99cd",
  null
  
)

export default component.exports